const apiConfig = {
  baseUrl: "https://api.themoviedb.org/3/",
  apiKey: "08500cdd9bf254973c40513e22c32c5a",
  originalImage: (imgPath) => `https://image.tmdb.org/t/p/original/${imgPath}`,
  w500Image: (imgPath) => `https://image.tmdb.org/t/p/w500/${imgPath}`,
};

export default apiConfig;
